<script setup>
  import { computed } from 'vue'
  import BcstProgressBar from './BcstProgressBar.vue'
  import BcsTooltip from '../BcsTooltip.vue'

  const props = defineProps({
    title: { type: String, default: '' },
    total: { type: Number, default: 0 },
    completedCount: { type: Number, default: 0 },
    percent: { type: Number, default: 0 },
    // Optional hint rendered as an info icon after the label. Empty = no icon.
    labelTooltip: { type: String, default: '' },
  })

  const progressLabel = computed(
    () => `${props.completedCount} of ${props.total} Lessons (${props.percent}% Complete)`
  )
</script>

<template>
  <div class="bmph-container">
    <p class="bmph-title">{{ title }}</p>
    <BcstProgressBar
      class="bmph-progress"
      :value="percent"
      size="sm"
      :isComplete="percent >= 100"
      iconSize="20px" />
    <p class="bmph-progress-label">
      {{ progressLabel }}<BcsTooltip
        v-if="labelTooltip"
        class="bmph-label-tooltip"
        :simpleText="labelTooltip"
        :show-arrow="true"
        :contentClass="'simple-text-tooltip'">
        <!-- BcsTooltip's trigger is a plain div: focusable + named here so keyboard and
             screen-reader users reach the hint the same way a mouse user does. -->
        <i
          class="bi bi-info-circle text-primary"
          role="img"
          tabindex="0"
          :aria-label="labelTooltip" />
      </BcsTooltip>
    </p>
  </div>
</template>

<style scoped lang="scss">
  .bmph-container {
    margin-bottom: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid var(--bs-gray-300);
  }

  .bmph-title {
    color: var(--bs-gray-700);
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.36px;
    margin-bottom: 12px;
    margin-top: 0;
  }

  .bmph-progress {
    margin-bottom: 8px;
  }

  .bmph-progress-label {
    color: var(--bs-body-color);
    font-size: 14px;
    letter-spacing: -0.28px;
    margin-bottom: 0;
  }

  /* Sits right after the label text, aligned with it. */
  .bmph-label-tooltip {
    margin-left: 4px;
    vertical-align: middle;
  }
</style>
